// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { z } from 'zod';
import { UtilityConfig } from '../config/config';

export const localStorageStateParser = (config: UtilityConfig) => {
  return z.object({
    pollingEnabled: z.stringbool().optional().default(true),
    webSocketEnabled: z.stringbool().optional().default(true),
    activeContractsLogsEnabled: z.stringbool().optional().default(config.acs.enableLogsByDefault),
    isDark: z.stringbool().optional().default(true),
  });
};

export type LocalStorageState = z.infer<ReturnType<typeof localStorageStateParser>>;

export interface LocalStorageContextProps {
  localStorageState: LocalStorageState;
  setLocalStorageState: <K extends keyof LocalStorageState>(
    key: K,
    val: LocalStorageState[K],
  ) => void;
}

export const LocalStorageContext = React.createContext({} as LocalStorageContextProps);

export const useLocalStorage = () => {
  return React.useContext(LocalStorageContext);
};
